module.exports = __webpack_public_path__ + "img/des_piano_04.9e7fce81.jpg";